// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QmtNb","content":"styles_content__KJz56"};